export default "__VITE_ASSET__1661b468__"